module.exports = __webpack_public_path__ + "static/media/more-rounded.c502167b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more-rounded.svg
// module id = 121
// module chunks = 0